export default class PivotParameters {
  constructor (indexDims, column) {
    this.index_dim = [indexDims]
    this.column = column
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/PivotParameters.js